module.exports = __webpack_public_path__ + "media/images/email-subscriber-banner-sp-d7928f4ff7e62cd06a649304671a58c0.png";